import { tableSchema } from '@nozbe/watermelondb';

import type { ITable } from './interface';

export const questionTable = {
  name: 'questions',
  columns: [
    {
      name: 'question_id',
      type: 'number',
    },
    {
      name: 'name',
      type: 'string',
    },
    {
      name: 'order',
      type: 'number',
      isOptional: true,
    },
    {
      name: 'description',
      type: 'string',
    },
    {
      name: 'is_dropdown',
      type: 'boolean',
    },
    {
      name: 'is_random_order_answer',
      type: 'boolean',
    },
    {
      name: 'step_id',
      type: 'number',
    },
    {
      name: 'answer_limit',
      type: 'number',
    },
    {
      name: 'created_by',
      type: 'string',
    },
    {
      name: 'updated_by',
      type: 'string',
    },
    {
      name: 'created_at',
      type: 'number',
    },
    {
      name: 'updated_at',
      type: 'number',
    },
  ],
} as ITable;

export const questionSchema = tableSchema(questionTable);
